import { Col, Modal, Row } from 'antd';
import { XSquare } from 'react-bootstrap-icons';
import PrimaryButton from '../buttons/PrimaryButton';
import DefaultButton from '../buttons/DefaultButton';

type FooterConfirmAction = {
  label: string;
  // onClick: MouseEventHandler;
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
};

type FooterCancelAction = {
  label: string;
  // onClick: MouseEventHandler;
  onClick: () => void;
};

type FormModelComponentProps = {
  styleClasses?: string;
  isOpen: boolean;
  onClickedCancel: any;
  header?: any;
  content: any;
  footer?: any;
  closeIcon?: any;
  headerContent?: any;
  footerAction?: {
    confimation?: FooterConfirmAction;
    cancel?: FooterCancelAction;
  };
  contentStyles?: string;
  subheader?: any;
};

const FormModelComponent = (props: FormModelComponentProps) => {
  const {
    styleClasses = '',
    isOpen,
    onClickedCancel,
    header,
    content,
    footer,
    closeIcon,
    headerContent,
    footerAction,
    contentStyles,
    subheader,
  } = props;

  const baseClasses =
    'z-50 !w-[95vw] max-w-[95vw] min-w-[320px] sm:!w-3/4 sm:max-w-[640px] md:!w-2/3 md:max-w-[700px] lg:!w-1/2 lg:max-w-[750px] xl:!w-1/3 xl:max-w-[600px]';

  const footerCancelAction = (cancelAction: FooterCancelAction) => (
    <DefaultButton handleOnClick={cancelAction.onClick} width="100%">
      {cancelAction.label}
    </DefaultButton>
    // <Button onClick={cancelAction.onClick} className="btn-default w-full rounded-2xl">
    //   {cancelAction.label}
    // </Button>
  );

  const footerConfirmAction = (confirmAction: FooterConfirmAction) => (
    <PrimaryButton handleOnClick={confirmAction.onClick} width="100%" hideBgGradient={true}>
      {confirmAction.label}
    </PrimaryButton>
    //  <Button
    //   onClick={confirmAction.onClick}
    //   loading={confirmAction.isLoading}
    //   htmlType="submit"
    //   disabled={confirmAction.isDisabled}
    //   className={`btn-primary w-full rounded-2xl`}
    // >
    //   {confirmAction.label}
    // </Button>
  );

  return (
    <Modal
      className={`${baseClasses} ${styleClasses}`}
      centered
      open={isOpen}
      footer={null}
      closeIcon={closeIcon ? closeIcon : <XSquare className="text-primary-gray-500" size={20} />}
      maskClosable={false}
      onCancel={onClickedCancel}
      destroyOnClose
      //   width={550}
    >
      <div>
        {headerContent ? (
          <Row justify="center">{headerContent}</Row>
        ) : (
          <>
            <Row justify="start">
              <label className="text-primary-font-gray mb-2 px-2 text-center text-xl font-bold">
                {header}
              </label>
            </Row>
            {subheader && (
              <Row>
                <p className="text-primary-font-gray mb-4 px-2 text-start text-sm font-normal">
                  {subheader}
                </p>
              </Row>
            )}
          </>
        )}
        {content.length !== 0 && (
          <div
            className={`${contentStyles ? contentStyles : 'mb-8 mt-4 max-h-[50vh] space-y-2 overflow-y-auto px-2 pt-4 text-center'} `}
          >
            {content}
          </div>
        )}
        <div className="px-1 md:px-2">
          {footerAction && footerAction.confimation && footerAction.cancel ? (
            <Row justify="center" className="my-2">
              <Col xs={24} sm={12} span={12} className="mb-4 pr-0 md:mb-0 md:pr-2">
                {footerCancelAction(footerAction.cancel)}
              </Col>
              <Col xs={24} sm={12} span={12} className="mt-2 pl-0 md:mt-0 md:pl-4">
                {footerConfirmAction(footerAction.confimation)}
              </Col>
            </Row>
          ) : footerAction && footerAction.confimation && !footerAction.cancel ? (
            <Row justify="center" className="my-2">
              <Col span={24} className="pl-4">
                {footerConfirmAction(footerAction.confimation)}
              </Col>
            </Row>
          ) : (
            footer
          )}
        </div>
      </div>
    </Modal>
  );
};

export default FormModelComponent;
